import React, { useState } from "react";
import "./Home.css";
import Guia from "../../assets/svg/guia.svg";
import Referencia from "../../assets/svg/referencia.svg";
import Tutorial from "../../assets/svg/tutorial.svg";
import Faq from "../../assets/svg/faq.svg";
import Arrow from "../../assets/svg/arrow.svg";
import ChatWindow from "../../components/ChatWindow";
import ChatIcon from "../../assets/svg/chat-icon.svg";

import { Link } from "react-router-dom";



function HomePage() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };
  

  return (
    <div className="home">
      <header className="home-header">
        <div className="home-header-background"></div>
        <div className="home-content">
          <h1>Bem-vindo ao Portal de APIs da SPC Grafeno!</h1>
          <p>
            Agradecemos por escolher a SPC Grafeno como sua parceira em soluções
            de dados e tecnologia. Este portal foi criado para fornecer todas as
            informações necessárias para integrar e utilizar nossas APIs de
            forma eficiente e eficaz.
          </p>
        </div>
      </header>
      <main className="home-main">
        <h3>Aqui você encontrará: </h3>
        <section className="home-cards">
          <div className="home-card">
            <img src={Guia} alt="Guia" />
            <h2>Guias de Início Rápido</h2>
            <p>Para ajudar você a começar rapidamente com nossas APIs.</p>
            <div className="home-card-btn">
              <button>
                <Link to="/registrativos#/096qde65y8864-ambientes-e-pre-requisitos">
                  Acessar
                  <img src={Arrow} alt="Arrow" />
                </Link>
              </button>
            </div>
          </div>
          <div className="home-card">
            <img src={Referencia} alt="Referencia" />
            <h2>Referências Completas</h2>
            <p>Documentação de todos os endpoints, parâmetros e respostas.</p>
            <div className="home-card-btn">
              <button>
                <Link to="/registrativos#/oh1pmiexvcpyn-registradora">
                  Acessar
                  <img src={Arrow} alt="Arrow" />
                </Link>
              </button>
            </div>
          </div>
          <div className="home-card">
            <img src={Tutorial} alt="Tutorial" />
            <h2>Tutoriais e Exemplos</h2>
            <p>
              Passo a passo e exemplos práticos para facilitar a integração.
            </p>
            <div className="home-card-btn">
              <button>
                <Link to="/registrativos#/kpvhq64frboq2-usando-a-api">
                  Acessar
                  <img src={Arrow} alt="Arrow" />
                </Link>
              </button>
            </div>
          </div>
          <div className="home-card">
            <img src={Faq} alt="Faq" />
            <h2>FAQs e Suporte</h2>
            <p>
              Respostas para perguntas comuns e contato com time de suporte.
            </p>
            <div className="home-card-btn">
              <button>
                <Link to="/faq-support">
                  Acessar
                  <img src={Arrow} alt="Arrow" />
                </Link>
              </button>
            </div>
          </div>
        </section>
        <section className="home-footer">
          <p>
            Nosso objetivo é fornecer uma experiência de integração suave e sem
            complicações. Explore a documentação, experimente nossas APIs e veja
            como podemos ajudar a impulsionar suas soluções de negócios.
          </p>
        </section>
      </main>
      <div className="chat-icon" onClick={toggleChat}>
        <img src={ChatIcon} alt="Chat Icon" />
      </div>
      <ChatWindow isOpen={isOpen} toggleChat={toggleChat} />
    </div>
      
  );
}

export default HomePage;
